module.exports = __webpack_public_path__ + "05f97ad20c9e72dc8b131db43842031e.pdf";